import { gql } from "@apollo/client";

export const GET_TESTIMONALS = gql`
  query getTestimonals {
    testimonialdata {
      testimonial_id
      testimonial_type
      status
      rating
      date
      name
      email
      message
      company
      website
      twitter
      facebook
      image
      designation
      video_url
    }
  }
`;

export default {
  getTestimonalsQuery: GET_TESTIMONALS,
};
